
import { DevicesServices, FreebiesServices } from '@gtpl/shared-services/canteen-management';
import { DepartmentService, EmployeeService, HrmsEmpDetService } from '@gtpl/shared-services/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { EmployeeFreebiesRepo } from './repository/employee-freebies.repository';
import { FreebiesConsumptionRepo } from './repository/freebies-consumption.repository';
import { TokenConsumptionService } from './token-consumption.service';
import { TokensHelperService } from './tokens-helper.service';
import { TokensAdapter } from './tokens.adapter';
import { TokensController } from './tokens.controller';
import { TokensService } from './tokens.service';
import { WhatsAppNotificationService } from "@gtpl/shared-services/notification-management";
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast';
import { FreebieRepo } from '../freebies/repository/freebies.repository';

@Module({
  imports: [
    TypeOrmModule.forFeature([
      EmployeeFreebiesRepo,
      FreebiesConsumptionRepo,
      FreebieRepo
    ])
  ],
  controllers: [TokensController],
  providers: [TokensService, TokenConsumptionService, TokensAdapter, TokensHelperService, FreebiesServices, DevicesServices, ApplicationExceptionHandler,EmployeeService,DepartmentService,WhatsAppNotificationService,WhatsappBroadCastService,HrmsEmpDetService],
  exports: [TokensService, TokenConsumptionService]
})
export class TokensModule { }
